import { render, staticRenderFns } from "./DataBlockUnitCost.vue?vue&type=template&id=031099cc&scoped=true"
import script from "./DataBlockUnitCost.vue?vue&type=script&lang=ts"
export * from "./DataBlockUnitCost.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031099cc",
  null
  
)

export default component.exports